import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import './register.css'
import Logo from '../../assets/register/Logo.svg'
import { authService } from '../../services/authService';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const SignupForm = ({ role }) => {
  const initialValues = {
    fullName: '',
    username: '',
    password: '',
    confirmPassword: '',
    // serviceType: '',
    branch: '',
    terms: false,
    role: role,
    ...(role !== 'trainer' && { serviceType: '' }),
  };
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const validationSchema = Yup.object({
    fullName: Yup.string().required('Full name is required'),
    username: Yup.string()
      .required('Email is required')
      .matches(
        /^(\S+@\S+\.\S+|\d{10,})$/,
        'Must be a valid email'
      ),
    password: Yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm Password is required'),
    branch: Yup.string().required('Please select a clinic branch'),
    terms: Yup.bool().oneOf([true], 'You must accept the terms and conditions'),
    ...(role !== 'trainer' && {
      serviceType: Yup.string().required('Please select a service type'),
    }),
  });

  const handleSubmit = async (values) => {
    const { terms, ...formData } = values;
    console.log('Form Submitted:', formData);

    // Send formData to API here
    setIsLoading(true);
    try {
      // Remove confirmPassword before sending to API
      // const { confirmPassword, ...registerData } = formData;

      const response = await authService.register(formData);
      if (response.success) {
        toast.success(response?.message)

        navigate('/login', { state: { message: 'Registration successful! Please login.' } });

      }
      else {
        toast.error(response?.message)
        console.log("responseresponse", response?.message)

      }
    } catch (err) {
      // setError(err.message || 'Registration failed');
    } finally {
      setIsLoading(false);
    }
  };
  // const handleSubmit = async (e) => {

  //   e.preventDefault();

  //   // Validate passwords match
  //   if (formData.password !== formData.confirmPassword) {
  //     setError('Passwords do not match');
  //     return;
  //   }

  //   setError('');
  //   setIsLoading(true);

  //   try {
  //     // Remove confirmPassword before sending to API
  //     const { confirmPassword, ...registerData } = formData;

  //     await authService.register(registerData);
  //     navigate('/login', { state: { message: 'Registration successful! Please login.' } });
  //   } catch (err) {
  //     setError(err.message || 'Registration failed');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <div className="login_box container ">
      <div className="row align-items-center">
        <div className="col-md-7">
          <div className="signup-left_image text">
            {/* Optional: Add image or content here */}
          </div>
        </div>
        <div className="col-md-5">
          <div className="login-form">
            <div className="text-center">
              <img src={Logo} className="login_logo" alt="Logo" />
              <h1>Create an account</h1>
            </div>

            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
              {() => (
                <Form>
                  {/* Full Name */}
                  <div className="mb-3">
                    <label htmlFor="fullName" className="form-label">Full Name</label>
                    <Field type="text" className="form-control" id="fullName" name="fullName" placeholder="Enter your full name" />
                    <ErrorMessage name="fullName" component="div" className="text-danger" />
                  </div>

                  {/* Email or Phone */}
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">Email</label>
                    <Field type="text" className="form-control" id="username" name="username" placeholder="Enter your email address" />
                    <ErrorMessage name="username" component="div" className="text-danger" />
                  </div>

                  {/* Password */}
                  <div className="mb-3 position-relative">
                    <label htmlFor="password" className="form-label">Password</label>
                    <div className="input-group">
                      <Field
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="Type your password"
                      />
                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                      </span>
                    </div>
                    <ErrorMessage name="password" component="div" className="text-danger" />
                  </div>

                  {/* Confirm Password Field */}
                  <div className="mb-3 position-relative">
                    <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                    <div className="input-group">
                      <Field
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        id="confirmPassword"
                        name="confirmPassword"
                        placeholder="Type your password"
                      />
                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        <i className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                      </span>
                    </div>
                    <ErrorMessage name="confirmPassword" component="div" className="text-danger" />
                  </div>

                  {/* Service Type */}
                  {
                    role !== "trainer" &&
                    <div className="mb-3">
                      <label htmlFor="serviceType" className="form-label">Service Type</label>
                      <Field as="select" className="form-select" id="serviceType" name="serviceType">
                        <option value="" disabled>Select a service</option>
                        <option value="skin_and_facial">Skin and Facials</option>
                        <option value="body_contouring">Body Contouring</option>
                        <option value="head_spa">Head Spa</option>
                        <option value="ipl_photo_rejuvenation">IPL Photo Rejuvenation</option>
                        <option value="fresha">Fresha</option>
                        <option value="welcome_video">Welcome Video</option>
                        <option value="laundry">Laundry</option>
                        <option value="setting_flipping_room">Setting & Flipping a Room</option>
                        <option value="how_to">How-to</option>
                        <option value="writing_prescriptions">Writing Prescriptions</option>
                        <option value="packages">Packages</option>

                        <option value="hydra_micro_dermabrasion">Hydra/Micro Dermabrasion</option>
                        <option value="microcurrent_facial">Microcurrent Facial</option>
                        <option value="extractions_millia_removal">Extractions/Millia Removal</option>
                        <option value="rf_skin_tightening">RF Skin Tightening</option>
                        <option value="fat_cavitation">Fat Cavitation</option>
                        <option value="ems">EMS</option>
                        <option value="skin_needling_nano">Skin Needling & Nano</option>
                        <option value="chemical_peels">Chemical Peels</option>
                        <option value="observ_machine">Observ Machine</option>
                        <option value="relax_facials">Relax Facials</option>
                        <option value="skin_consults">Skin Consults</option>
                        <option value="body_consult">Body Consult</option>
                        <option value="hale_hush_facials">Hale and Hush Facials</option>
                        <option value="elemental_facials">Elemental Facials</option>
                        <option value="kids_teens_facials">Kids and Teens Facials</option>
                        <option value="specialised_body_treatments">Specialised Body Treatments</option>
                        <option value="body_scrubs">Body Scrubs</option>
                        <option value="relax_hot_stones_massage">Relax & Hot Stones Massage</option>
                        <option value="lymphatic_massage">Lymphatic Massage</option>
                        <option value="sauna">Sauna</option>
                        <option value="vacuum_therapy">Vacuum Therapy</option>
                        <option value="hifu">HIFU</option>
                        <option value="facial_body_waxing">Facial & Body Waxing</option>
                        <option value="facial_tinting">Facial Tinting</option>
                        <option value="brow_lamination">Brow Lamination</option>
                        <option value="lash_lift">Lash Lift</option>
                        <option value="full_glam_brows_lashes">Full Glam, Brows & Lashes</option>
                        <option value="teeth_whitening">Teeth Whitening</option>
                        <option value="led_therapy">LED Therapy</option>
                        <option value="dermaplaning">Dermaplaning</option>
                        <option value="carbon_laser_facial">Carbon Laser Facial</option>


                      </Field>
                      <ErrorMessage name="serviceType" component="div" className="text-danger" />
                    </div>
                  }


                  {/* Clinic Branch */}
                  <div className="mb-3">
                    <label htmlFor="branch" className="form-label">Clinic Branch</label>
                    <Field as="select" className="form-select" id="branch" name="branch">
                      <option value="" disabled>Select a branch</option>
                      <option value="alphington">Alphington</option>
                      <option value="ringwood">Ringwood</option>
                      <option value="ringwood/alphington">Ringwood/Alphington</option>
                      {/* <option value="C">Branch 03</option> */}
                    </Field>
                    <ErrorMessage name="branch" component="div" className="text-danger" />
                  </div>

                  {/* Terms and Conditions */}
                  <div className="mb-3 form-check">
                    <Field type="checkbox" className="form-check-input" id="termsCheck" name="terms" />
                    <label className="form-check-label" htmlFor="termsCheck">
                      By creating an account, you agree to our <a href="/terms&condition">Terms & Conditions</a> and our <a href="https://www.empoweringbeautyau.com/privacy-policy">Privacy Policy</a>.
                    </label>
                    <ErrorMessage name="terms" component="div" className="text-danger" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="btn btn-custom w-100" style={{ color: 'white' }}>
                    {isLoading ? "loadin...." : "Register"}
                  </button>
                </Form>
              )}
            </Formik>
            <div style={{ textAlign: 'center', marginTop: '35px' }}>
              <span style={{ color: '#5c4b3b', fontWeight: 500 }}>
                Already have an account?{' '}
                <Link
                  to="/login"
                  style={{
                    textDecoration: 'none',
                    color: '#5c4b3b',
                    borderBottom: '1px solid transparent',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={(e) => (e.target.style.borderBottom = '1px solid #5c4b3b')}
                  onMouseLeave={(e) => (e.target.style.borderBottom = '1px solid transparent')}
                >
                  Login
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
